import { render, staticRenderFns } from "./k-form-item.vue?vue&type=template&id=1fb7746c&v-slot%3AformItem=true"
import script from "./k-form-item.vue?vue&type=script&lang=js"
export * from "./k-form-item.vue?vue&type=script&lang=js"
import style0 from "./k-form-item.vue?vue&type=style&index=0&id=1fb7746c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports